import APIService from '@/services/APIService.js';

export default {

  uploadFileIcms(postData, updateOnLoad, extra, caminhoTmp) {
    return APIService.apiCall().post(`/bulldozerr/upload?base=icms&caminho_tmp=${caminhoTmp}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadFileCoge(postData, updateOnLoad, extra, caminhoTmp) {
    return APIService.apiCall().post(`/bulldozerr/upload?base=coge&caminho_tmp=${caminhoTmp}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadFileSdi(postData, updateOnLoad, extra, caminhoTmp) {
    return APIService.apiCall().post(`/bulldozerr/upload?base=sdi&caminho_tmp=${caminhoTmp}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadFileBdgdAnterior(postData, updateOnLoad, extra, caminhoTmp) {
    return APIService.apiCall().post(`/bulldozerr/upload?base=bdgd_ant&caminho_tmp=${caminhoTmp}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadFileBdgdAtual(postData, updateOnLoad, extra, caminhoTmp) {
    return APIService.apiCall().post(`/bulldozerr/upload?base=bdgd_at&caminho_tmp=${caminhoTmp}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  deleteFile(fileId) {
    return APIService.apiCall().post(`bulldozerr/deletarArquivo?fileId=${fileId}`);
  },

  save(postData) {
    return APIService.apiCall().post('bulldozerr/save', postData);
  },

  getEmpresas() {
    return APIService.apiCall().get('bulldozerr/allEmpresasBulldozerr');
  },

  getBulldozerrs() {
    return APIService.apiCall().get('bulldozerr/getAllBulldozerr');
  },

  deletar(id) {
    return APIService.apiCall().post(`bulldozerr/delete?id=${id}`);
  },

  executar(id) {
    return APIService.apiCall().get(`/bulldozerr/executar/${id}`);
  },

  download(id, type) {
    return APIService.apiCall().get(`/bulldozerr/downloadArquivoResultado/${id}/${type}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },

  baixarLogs(id, type) {
    return APIService.apiCall().get(`/bulldozerr/downloadLogs/${id}/${type}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  }
};
